import buildVersion from '@env/buildVersion';
import { BuildVersion, IEnvironment } from './environment.interface';

const gatewayUrl = 'https://api-document-gateway.portalct.mynexuscare.com';
const platformApiUrl = 'https://api-platform.portalct.mynexuscare.com';

export const environment: IEnvironment = {
  gatewayUrl,
  platformApiUrl,
  modules: [],
  production: false,
  routes: [],
  version: buildVersion as BuildVersion,
};
